export default __webpack_public_path__ + "static/media/1018.cb74fe58.png";